import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../diccionarios/comisionesModulo';

@Injectable({
  providedIn: 'root'
})
export class ReporteDeLiquidacionIndividualService {

  diccionarioUrl: any;
  urlMaestros: string;
  urlComisiones: string;
  constructor(
    private commom: CommonService,
    private utilServices: UtilsService
  ) {
    this.urlMaestros = this.utilServices.getDatosMaestros();
    this.urlComisiones = this.utilServices.getComisiones();
    this.diccionarioUrl = comisionesModulo.url.reporteLiquidacionIndividual;
  }

  getTodo(innObj: any) {
    // let url = this.urlComisiones + this.diccionarioUrl.obtenerTodo + 'anio=' + innObj.anio + '&inicioMes=' + innObj.inicioMes + '&finMes=' + innObj.finMes + '&tipoVendedor=' + innObj.tipoVendedor;
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.obtenerTodo, innObj);
  }

  getTiposDeVendedores() {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerTodo);
  }

  getReporteTotal(innObj: any) {
    let url = this.urlComisiones + this.diccionarioUrl.reporteTotal + 'anio=' + innObj.anio + '&inicioMes=' + innObj.inicioMes + '&finMes=' + innObj.finMes + '&tipoVendedor=' + innObj.tipoVendedor;
    return this.commom.peticionPostConHeader(innObj.vendedorId ? url +  '&vendedorId=' + innObj.vendedorId : url, innObj);
  }

  getReporteIndividual(innObj: any) {
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.reporteIndividual + 'anio=' + innObj.anio + '&mes=' + innObj.mes + '&tipoVendedor=' + innObj.tipoVendedor + '&vendedorId=' + innObj.vendedorId, innObj);
  }

}
